

















import {
  defineComponent,
  ref,
  useContext,
  useFetch,
} from '@nuxtjs/composition-api';
import { useCache } from '@vue-storefront/cache';
import merge from 'lodash-es/merge';

import ProductBreadcrumbs from '~/components/Breadcrumbs/ProductBreadcrumbs.vue';
import SimpleProduct from '~/components/Product/components/SimpleProduct/SimpleProduct.vue';
import useProductPage from '~/composables/useProductPage';
import { AVAILABLE_PRODUCT_VISIBILITY } from '~/constants';
import { getProductTags } from '~/helpers/cacheHelpers';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { RouteData } from '~/middleware/url-resolver';
import ProductSkeleton from '~/modules/catalog/product/components/ProductSkeleton.vue';
import { useProduct } from '~/modules/catalog/product/composables/useProduct';
import type { Product } from '~/modules/catalog/product/types';
import { ProductInterface } from '~/modules/GraphQL/types';
import { usePageStore } from '~/stores/page';

export default defineComponent({
  name: 'ProductPage',
  components: {
    SimpleProduct,
    ProductBreadcrumbs,
    ProductSkeleton,
  },
  setup() {
    const { routeData, product: productFromStore } = usePageStore();
    const product = ref<ProductInterface | null>(productFromStore);
    const { addTags } = useCache();
    const { getProductDetails, loading } = useProduct();
    const { error: nuxtError } = useContext();
    const { loadReviews: fetchReviews } = useProductPage();

    const getBaseSearchQuery = () => ({
      filter: {
        sku: {
          eq: routeData.sku,
        },
      },
    });

    const fetchProductBaseData = async (searchQuery = getBaseSearchQuery()) => {
      const result = await getProductDetails({
        ...searchQuery,
      });

      product.value = merge({}, product.value, result.items[0] as Product ?? null);
    };

    useFetch(async () => {
      if (!product.value) {
        await fetchProductBaseData();
      }

      if (Boolean(product?.value?.sku) === false || !AVAILABLE_PRODUCT_VISIBILITY.includes(product?.value?.visibility)) {
        nuxtError({ statusCode: 404 });
        return;
      }

      await fetchReviews(product);

      addTags(getProductTags(product.value));
    });

    return {
      loading,
      product,
      routeData,
    };
  },
  head() {
    return getMetaInfo(this.product, false, (this.routeData as RouteData).canonicalUrl, true, true);
  },
});
